import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faq } from '../../../content/site'

// FAQ accordion, rebuilt as a real disclosure widget (Task 9). The old markup was a <div
// onClick=...> - unreachable by keyboard, invisible to a screen reader. Same content, same
// independent-per-item open/close behaviour (not a single-open accordion - matches the old
// items.jsx, which gave every QNAItem its own useState), correct markup:
//   - the question is a real <button type="button"> carrying aria-expanded and
//     aria-controls, so it is focusable, activates on Enter/Space like any button, and
//     announces its state to assistive tech;
//   - the answer is a <div id=...> that aria-controls points at, with role="region" and
//     aria-labelledby back to the button (a standard disclosure/accordion pairing);
//   - the answer is NEVER conditionally unmounted - it stays in the DOM at all times and is
//     only visually collapsed via CSS (grid-template-rows 0fr/1fr on a wrapper, the modern
//     animatable-height technique - see the FAQ banner in site.css), so the 13-pairs-worth
//     (here: 7, see content/site.js) of answer copy stays indexable even when collapsed.
//
// FontAwesome (not an inline SVG from components/site/icons.jsx): the old component already
// depended on @fortawesome/react-fontawesome + free-solid-svg-icons for this exact chevron
// job (faArrowDown), so swapping to faChevronDown - the conventional accordion affordance -
// costs nothing new in the bundle. icons.jsx's registry is keyed for Service/PortalFeature
// glyphs (crown, implant, printer...), not chevrons, so reusing it would mean adding an
// unrelated entry to a registry that has no other UI-chrome icons in it.
const Items = () => {
  return (
    <section className="section faq-section">
      <div className="container faq-container">
        {faq.items.map((item, i) => (
          <FaqItem key={i} index={i} item={item} />
        ))}
      </div>
    </section>
  )
}

const FaqItem = ({ item, index }) => {
  const [open, setOpen] = useState(false)
  const triggerId = `faq-trigger-${index}`
  const panelId = `faq-panel-${index}`

  return (
    <div className="faq-item">
      <h3 className="faq-question">
        <button
          type="button"
          id={triggerId}
          className="faq-trigger"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((o) => !o)}
        >
          <span>{item.question}</span>
          <FontAwesomeIcon
            icon={faChevronDown}
            aria-hidden="true"
            className={`faq-chevron${open ? ' is-open' : ''}`}
          />
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={triggerId}
        className={`faq-answer${open ? ' is-open' : ''}`}
      >
        <div className="faq-answer-inner">
          <p className="faq-answer-text">{item.answer}</p>
        </div>
      </div>
    </div>
  )
}

export default Items
